import { type ReactNode } from 'react';
import { useWide } from '@/platform/useWide';
import { runtime } from '@/platform/runtime';
import { SceneContent } from './scene/SceneContent';
import { SceneWords } from './scene/SceneWords';
import styles from './DesktopStage.module.css';

interface Props {
  children: ReactNode;
}

export function DesktopStage({ children }: Props) {
  const isWide = useWide(1100);

  if (!isWide || !runtime.isStandalone) return <>{children}</>;

  return (
    <div className={styles.wrapper}>
      <div className={styles.stage}>
        <div data-theme="dark"><SceneWords /></div>
        <div data-theme="dark" className={styles.sceneCol}>
          <SceneContent />
        </div>
        <div className={styles.phone}>
          {children}
        </div>
      </div>
    </div>
  );
}
